export default __webpack_public_path__ + "static/media/water-waves.dfb3fac5.mp3";